import { createIcon } from 'src/components/icons/icon-utils';

export const ScrollRightIcon = createIcon({
  path: 'M 5.468638 4.80678 C 6.01712 4.4074 6.017121 3.58937 5.468638 3.18999 L 1.70594 0.45016 C 1.04503 -0.03108 0.1173 0.44101 0.1173 1.25856 L 0.1173 6.73822 C 0.1173 7.555768 1.04503 8.027854 1.70594 7.546612 L 5.468638 4.80678 Z',
  viewBox: '0 0 6 8',
});
